/*
 * Public API Surface of funcionalidade
 */

export * from './lib/cadastrar-contratante.component.module';
